<template>
  <b-dropdown
    position="is-bottom-left"
    append-to-body
    aria-role="menu"
    class="custom-notification-button"
  >
    <template #trigger>
      <div class="notification-button">
        <button style="background-color: transparent; border: none">
          <IconBell
            class="icon"
            :class="[notifications.length > 0 ? 'color-8' : 'color-9']"
          />
        </button>
        <span v-if="notifications.length > 0" class="notification-badge">
          {{ notifications.length }}
        </span>
      </div>
    </template>
    <div v-if="notifications.length > 0">
      <b-dropdown-item
        v-for="notification in notifications"
        :key="notification.id"
        class="notification-item"
      >
        <b-navbar-item tag="a" @click.native="goTo(notification)">
          <div class="notification-message">
            {{ notification.message }}
          </div>
          <div class="notification-date">
            {{ formatDate(notification.timestamp) }}
          </div>
        </b-navbar-item>
      </b-dropdown-item>
    </div>
    <div v-else class="notification-empty">No notifications.</div>
  </b-dropdown>
</template>

<script>
import IconBell from "@/components/icons/IconBell.vue";
import { mapGetters } from "vuex";
import { FEATURE_NAME } from "@/constants";
import { PATH_INFO } from "@/router/path";
import { DATA_TEST_ID_VALUES } from "@/constants/test";

export default {
  name: "NavbarItemNotification",
  components: { IconBell },
  data() {
    return {
      featureName: FEATURE_NAME,
      paths: { ...PATH_INFO },
      constants: { DATA_TEST_ID_VALUES },
    };
  },
  computed: {
    ...mapGetters({
      notifications: "users/getUnreadNotifications",
    }),
  },
  methods: {
    formatDate(timestamp) {
      return new Date(timestamp * 1000).toLocaleString("es-PE");
    },
    async goTo(notification) {
      await this.$store.dispatch("users/readNotification", notification.id);
      location.href = notification.location;
    },
  },
};
</script>

<style scoped>
.notification-button {
  position: relative;
  display: inline-block;
}

.notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #f14668;
  color: white;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-item {
  border-bottom: 1px solid #f0f0f0;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item .navbar-item {
  width: 320px;
  padding: 12px 15px;
  white-space: normal;
  display: block;
}

.notification-item .navbar-item:hover {
  background-color: #f7f8fa;
}

.notification-message {
  color: #363636;
  font-size: 13px;
  line-height: 1.4;
}

.notification-date {
  margin-top: 5px;
  color: #999;
  font-size: 11px;
}

.notification-empty {
  width: 320px;
  padding: 25px 15px;
  text-align: center;
  color: #999;
  font-size: 13px;
}
</style>

<style>
.custom-notification-button .dropdown-menu {
  padding: 0;
  overflow: hidden;
}

.custom-notification-button {
  margin: 0;
}
</style>
